import qs from 'qs'

import api from '@/services/base.service'

const methods = {
  getRecuentosNuevos() {
    return api.get(`/recuentos/nuevos`)
  },
  downloadRecuento(id) {
    return api.post(`/recuentos/${id}/descargar`)
  },
  getRecuentos(bodegaId) {
    return api.get(`/recuentos`, {
      params: {
        bodegaId,
        estados: ['Abierto', 'Completado', 'ActualizandoSap']
      },
      paramsSerializer: (params) => qs.stringify(params)
    })
  },
  getRecuento(recuentoId) {
    return api.get(`/recuentos/${recuentoId}`, {
      params: {
        includeItems: false
      },
      paramsSerializer: (params) => qs.stringify(params)
    })
  },
  getArticulosByRecuento(recuentoId, page, pageSize, busqueda) {
    return api.get(`/recuentos/${recuentoId}/articulos`, {
      params: { page: page - 1, pageSize, busqueda },
      paramsSerializer: (params) => qs.stringify(params)
    })
  },
  closeRecuento(recuentoId) {
    return api.post(`/recuentos/${recuentoId}/completar`)
  },
  cancelarRecuento(recuentoId) {
    return api.post(`/recuentos/${recuentoId}/cancelar`)
  },
  finalizarRecuento(recuentoId) {
    return api.post(`/recuentos/${recuentoId}/finalizar`)
  },
  exportarRecuento(recuentoId) {
    return api.get(`/recuentos/${recuentoId}/exportar`, {
      responseType: 'blob'
    })
  },
  exportarUbicacionesRecuento(recuentoId) {
    return api.get(`/recuentos/${recuentoId}/exportar-ubicaciones`, {
      responseType: 'blob'
    })
  },
  exportarResumenRecuento(recuentoId) {
    return api.get(`/recuentos/${recuentoId}/exportar-resumen`, {
      responseType: 'blob'
    })
  },
  cambiarTipoRecuento(recuentoId) {
    return api.patch(`/recuentos/${recuentoId}/cambiar-tipo`)
  },
  getFolios(recuentoId) {
    return api.get(`/recuentos/${recuentoId}/folios`)
  },
  getFoliosValidos(
    recuentoId,
    page,
    pageSize,
    busquedaArticulo,
    busquedaFolio
  ) {
    return api.get(`/recuentos/${recuentoId}/folios-validos`, {
      params: { page: page - 1, pageSize, busquedaArticulo, busquedaFolio },
      paramsSerializer: (params) => qs.stringify(params)
    })
  },
  addFolio(folio) {
    return api.post(`/folios`, folio)
  },
  cancelarFolio(folio) {
    return api.delete(`/folios/${folio}/cancelar`)
  },
  toggleFolioItem(folioId, articuloId, valor, todos = false) {
    return api.post(`/folios/${folioId}/items/${articuloId}/marcar`, {
      valor,
      todos
    })
  },
  getRecuentoMetadata(recuentoId, busqueda) {
    return api.get(`/recuentos/${recuentoId}/metadata`, {
      params: { busqueda },
      paramsSerializer: (params) => qs.stringify(params)
    })
  },
  uploadFolioFile(file) {
    const formData = new FormData()
    formData.append('file', file)
    return api.post(`/folios/upload-file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

export default methods
